export default "__VITE_ASSET__DSCDcO10__"